import { Box, Image, NeoColor, P3 } from "@noom/wax-component-library";

export type TreatmentActionLinkRowData = {
  label: string;
  url: string;
  iconUrl?: string | null;
};

type TreatmentActionLinkRowProps = {
  link: TreatmentActionLinkRowData;
  onClick: () => void;
  /** When true, rows stack flush inside a grouped card (no per-row corner radius). */
  grouped?: boolean;
};

export const TreatmentActionLinkRow = ({
  link,
  onClick,
  grouped = false,
}: TreatmentActionLinkRowProps) => (
  <Box
    as="button"
    type="button"
    width="100%"
    textAlign="left"
    border="none"
    borderRadius={grouped ? 0 : "12px"}
    borderBottom={
      grouped ? `1px solid ${NeoColor.greyscale.gray1}` : undefined
    }
    bg={NeoColor.greyscale.white}
    px={4}
    py={3}
    cursor="pointer"
    onClick={onClick}
    display="flex"
    alignItems="center"
    gap={3}
    _hover={{ bg: NeoColor.greyscale.lightGray }}
  >
    {link.iconUrl ? (
      <Image
        src={link.iconUrl}
        alt=""
        width="24px"
        height="24px"
        flexShrink={0}
        objectFit="contain"
      />
    ) : (
      <Box width="24px" flexShrink={0} />
    )}
    <P3 fontWeight="normal" color={NeoColor.greyscale.black} flex="1" minWidth={0}>
      {link.label}
    </P3>
  </Box>
);
